/** Path of the Favorites Home; a Favorite's arrivals page lives under it. */
export const FAVORITES_PATH = "/favorites";

/** The Favorites Home or any page under it, but not e.g. `/favorites-foo`. */
export function isFavoritesPath(pathname: string): boolean {
  return (
    pathname === FAVORITES_PATH || pathname.startsWith(`${FAVORITES_PATH}/`)
  );
}
